import type { Repository } from "@octopusdeploy/octopus-server-client";
import type { GitHubConnectionsPageLoaderData } from "~/areas/library/components/GitConnections/GitHubConnectionsPageInternal";
import { getAuthorizationStatus, GitHubConnectionsPageInternal } from "~/areas/library/components/GitConnections/GitHubConnectionsPageInternal";
interface PlatformHubGitHubConnectionsPageProps {
    loaderData: GitHubConnectionsPageLoaderData;
}
export async function platformHubGitHubConnectionsPageLoader(repository: Repository): Promise<GitHubConnectionsPageLoaderData> {
    const authorizationStatus = await getAuthorizationStatus(repository);
    return {
        connections: { Connections: [] },
        authorizationStatus,
        notConnectedInstallations: { Installations: [] },
    };
}
export function PlatformHubGitHubConnectionsPage({ loaderData }: PlatformHubGitHubConnectionsPageProps) {
    return <GitHubConnectionsPageInternal loaderData={loaderData}/>;
}
